const TRUSTED_DOMAIN = '@trustedhealth.com';

function isEmailFromTrusted(email: string): boolean {
  return email.includes(TRUSTED_DOMAIN);
}

export { isEmailFromTrusted };
